import styled, { css } from 'styled-components';
import {Typo} from "components/common/ui";
import {themeToken} from "components/common/cpds/utils/cpds-utils";
import {mediaQueries} from "components/common/cpds/token/shared/common";

const Container = styled.div`
  ${({theme: {styles: {cpds}}, ...props}) => {
  const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
  return css`
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 7.5px 7.5px;
    transition: opacity 0.5s ease-in-out;
    opacity: ${(props) => props.visible ? 1 : 0};
    
    ${(props) => props?.styleOverrides}
  `;
}}
`;

export {
  Container,

}